import { FormInstance } from "antd";
import { useCallback, useState } from "react";
import { ITaskSingle } from "../types";
import dayjs from "../../../configs/dayjs";
import { DEFAULT_TIME_FORMAT } from "../../../lib/constants";

export const useSetForm = (form: FormInstance) => {
  const [data, setData] = useState<any>(null);

  const setForm = useCallback(
    (values: ITaskSingle) => {
      const { fileName } = values;

      const formValues: any = {
        document: {
          visibility: 0,
        },
      };

      formValues.file = [
        {
          name: fileName,
          status: "done",
          type: "application/pdf",
          size: 1,
        },
      ];

      if (values.taskType !== 1) {
        formValues.notificationRecipientTypes = {
          Requester: true,
        };
      }

      if (values.assignedToUserId) {
        formValues.assignedToUserId = values.assignedToUserId;
      }

      setData({
        ...values,
        sentAt: dayjs(values.sentAt).format(DEFAULT_TIME_FORMAT),
        closed: `${dayjs(values.closedAt).format(DEFAULT_TIME_FORMAT)} by ${values.closedBy}`,
      });

      form.setFieldsValue(formValues);
    },
    [form],
  );

  return { setForm, data };
};
